import React, { type FC } from "react";
import UnsetZIndexHelper from "../../../../../../../common-deprecated/components/UnsetZIndexHelper";
import { MAIN_NAV_CLASSNAME_TOYOTA } from "../../../../../../../common-deprecated/constants";
import ModalBaseView from "../../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import * as Modal from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Modal";
import Icon from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { IconWrapper } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import { MODAL_TRADE_IN_WRAPPER } from "../../../../../../../shared-logic/features/tradein/utils/modalConstants";

type Props = { children: React.ReactElement; closeModal: () => void };

/**
 * Wrapper modal for trade-in integrated.
 * Used in the IntegratedTradeInAemModal component.
 * !! Keep in mind that this component has a duplicate for the standalone. !!
 * src/tradein/components/lexus/common/TradeInAemModalWrapper.tsx
 */
const TradeInAemModalWrapper: FC<Props> = ({ children, closeModal }) => {
    return (
        <div>
            <UnsetZIndexHelper enabled selectors={[MAIN_NAV_CLASSNAME_TOYOTA, ".fluid.scroll"]} />
            <ModalBaseView modalIdType={MODAL_TRADE_IN_WRAPPER} onClose={closeModal} show size="lg" disableOutsideClick>
                <Modal.Header hasBackground>
                    <Modal.Button onClick={closeModal}>
                        <IconWrapper>
                            <Icon variant="close" />
                        </IconWrapper>
                    </Modal.Button>
                </Modal.Header>
                <Modal.Body noSpacing>{children}</Modal.Body>
            </ModalBaseView>
        </div>
    );
};

export default TradeInAemModalWrapper;
